import { GuildDataBlockDefinition } from '~/features/guild/types'
import { Days } from '~/shared/types/base/units'

/** 默认分成比例 */
export const DEFAULT_GUILD_CONTRACT_RATE = 45

export const GUILD_STREAMER_OVERVIEW_DATA_DEFINITIONS: GuildDataBlockDefinition[] = [
  {
    name: '开播主播数',
    description: '所选时间段内公会内所有有开播行为的主播数',
  },
  {
    name: '新主播数',
    description: '近 30 天内入会的主播数',
  },
  {
    name: '人均收听时长',
    description: '所选时间用户收听时长的求和 / 人数（同一用户进行去重）',
  },
]

export const GUILD_STREAMER_TABLE_DATA_DEFINITIONS: GuildDataBlockDefinition[] = [
  {
    name: '人均收听时长',
    description: '所选时间用户收听时长的求和 / 人数（同一用户进行去重）',
  },
  {
    name: '超 5 分钟收听占比',
    description:
      '所选时间段进直播间且在同一直播间收听累计超过 5 分钟的人数 / 所选时间进直播间人数总和（每日对同一用户进行去重）',
  },
]

export const LIMIT_RANGE_OF_DAYS = 60 as Days
